import { render, staticRenderFns } from "./ActivityFormPanelDateTask.vue?vue&type=template&id=3b6bb770&scoped=true&"
import script from "./ActivityFormPanelDateTask.vue?vue&type=script&lang=js&"
export * from "./ActivityFormPanelDateTask.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFormPanelDateTask.vue?vue&type=style&index=0&id=3b6bb770&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6bb770",
  null
  
)

export default component.exports